import { render, staticRenderFns } from "./NewBookAndChapterForm.vue?vue&type=template&id=04823e40"
import script from "./NewBookAndChapterForm.vue?vue&type=script&lang=js"
export * from "./NewBookAndChapterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports